// extracted by mini-css-extract-plugin
module.exports = {"level":"Footer_level__3ebY5","levelRight":"Footer_levelRight__244qr"};